import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { AppState } from '../app.service';
import { Integration } from '../integration/Integration';
import { NotificationService } from '../shared/generic-notification/notification.service';
import { SamlService } from './saml.service';

@Component({
    selector: 'saml',
    template: '',
    standalone: false
})
export class SAMLComponent {
    constructor(private readonly route: ActivatedRoute,
        public appState: AppState,
        private readonly samlService: SamlService,
        private readonly notificationService: NotificationService,
        private readonly storage: SessionStorageService) {
        this.notificationService.loadingEvent.next({ showLoading: true, loadingMessage: 'Loading App..!' });
        this.route.queryParams.subscribe({
            next: (_params) => {
                this.samlService.handleSessionInitiation(() => this.appState.getInitialToken(true, this.storage.retrieve('INTEGRATION_DATA') as Integration))
                    .then(_res => {
                        this.notificationService.loadingEvent.next({ showLoading: false });
                    }).catch(_error => {
                        this.notificationService.loadingEvent.next({
                            showLoading: true,
                            loadingMessage: 'Error Initiating App..!'
                        });
                    });
            },
            error: (err) => console.error('Error while parsing SAML response', err)
        });
    }
}
